import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import { useNavigate } from 'react-router-dom';
import cx from 'classnames';
import styles from './playground.module.scss';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import Split from 'react-split';
import Editor, { Monaco, useMonaco } from '@monaco-editor/react';
import { useEffect, useRef } from 'react';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import Dropdown from '@cp/src/components/Dropdown';
import { keywords, languageConfig, theme } from '../EditStrategy/constants';

const Playground = () => {
  const navigate = useNavigate();
  const editorRef = useRef(null);
  const monaco = useMonaco();

  useEffect(() => {
    if (monaco) {
      monaco?.languages?.register({ id: 'strategyLanguage' });
      monaco?.languages?.setMonarchTokensProvider('strategyLanguage', {
        ...languageConfig
      });
      monaco.editor.defineTheme('strategy-theme', {
        ...theme
      });

      monaco?.languages?.registerCompletionItemProvider('strategyLanguage', {
        provideCompletionItems: function () {
          const suggestions = [
            ...keywords.map(k => {
              return {
                label: k,
                kind: monaco.languages.CompletionItemKind.Keyword,
                insertText: k
              };
            })
          ];
          return {
            suggestions: suggestions
          };
        }
      });
    }
  }, [monaco]);

  function handleEditorDidMount(editor: Monaco) {
    editorRef.current = editor;
  }
  return (
    <div>
      <div className={styles.topNavContainer}>
        <div className={cx('cursor-pointer')} onClick={() => navigate(-1)}>
          <BackIcon size={'16'} />
        </div>
      </div>
      <div className="px-4">
        <div className="flex flex-row items-center justify-start gap-[30px]">
          <Typography variant="h1" className="ml-0 mt-4 mb-6">
            Playground
          </Typography>
        </div>
        <Split
          className="split"
          sizes={[50, 50]}
          minSize={100}
          expandToMin={false}
          gutterSize={20}
          gutterAlign="center"
          snapOffset={30}
          dragInterval={1}
          direction="horizontal"
          cursor="col-resize"
        >
          <div>
            <Editor
              height="75vh"
              defaultLanguage="strategyLanguage"
              defaultValue="// some comment"
              onMount={handleEditorDidMount}
              value={`
timeline "PLCollectionsTimeline" {
    description = "Personal Loan Timeline"
    product_codes = [PL-001, PL-002]
    anchor_date = "FIRST_UNPAID_DUE_DATE"
}
strategy "PresentMandateStrategy" {
    timeline = "PLCollectionsTimeline"
    description = "Present Mandate for emi > 5000 cases"
    condition = "contains(segments, UNPAID_MP_CUST_EMI_MT_5K)"
    dpad = [30..60]
    intent = "mandate"
    init_time = "11:47"
    pre_action = {}
    actions = {
        PRESENT_MANDATE {
            type = "static"
            amount_percentage = "100"
            balance_source = "SPADE"
        }
    }
}
`}
            />
          </div>
          <>This is the document guidelines for writing Strategy</>
        </Split>
        <div className="fixed bg-[var(--bg-primary-warm)] bottom-0 left-[64px] p-4 w-full">
          <Button variant="primary">Validate Strategy</Button>
        </div>
      </div>
    </div>
  );
};

export default Playground;
